"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorSubForm = void 0;
const form_palette_1 = require("../form.palette");
const form_field_editor_1 = require("./form.field.editor");
const form_field_tree_view_1 = require("./form.field.tree.view");
class FormFieldEditorSubForm extends form_field_editor_1.FormFieldEditor {
    viewTree() {
        return form_field_tree_view_1.FormFieldTreeView.viewForm(this);
    }
    viewInfoRW() {
        return form_palette_1.FormDesignerPalette.view(type => this.designer.createField(this.field, type), this.depth);
    }
}
exports.FormFieldEditorSubForm = FormFieldEditorSubForm;
//# sourceMappingURL=form.field.editor.subform.js.map